// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"90280c2a","830":"37754b52"}[chunkId] + ".chunk.js";
};